export default "__VITE_ASSET__fd72c742__"